module.exports = {
  "/": {
    "name": "storefront-home",
    "success": {
      "storefront home loaded": [
        "STOREFRONT_HOME_LOAD"
      ]
    }
  },
  "/categories": {
    "name": "all-categories",
    "success": {
      "all categories loaded": [
        "THEMES_ALL_BUSINESS_TYPES_LOAD"
      ]
    }
  },
  "/all": {
    "name": "all-storefront",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/all/page/:pageNumber": {
    "name": "all-storefront-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/:slugOrCategory": {
    "name": "theme-details-or-category",
    "success": {
      "theme details loaded": [
        "THEME_DETAILS_LOAD"
      ],
      "theme details preview forbidden error": [
        "THEME_DETAILS_FORBIDDEN_ERROR_LOAD"
      ],
      "theme details 404": [
        "THEME_DETAILS_403_LOAD"
      ],
      "theme details 403": [
        "THEME_DETAILS_404_LOAD"
      ],
      "themes loaded": [
        "THEMES_LOAD"
      ]
    },
    "error": [
      "THEME_DETAILS_ERROR_LOAD"
    ]
  },
  "/:category/page/:pageNumber": {
    "name": "storefront-category-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/:category/:subcategory": {
    "name": "storefront-category-subcategory",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  },
  "/:category/:subcategory/page/:pageNumber": {
    "name": "storefront-category-subcategory-page",
    "success": {
      "themes loaded": [
        "THEMES_LOAD"
      ]
    }
  }
};